import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import api, { getImageUrl } from '../services/api';
import { useSettings } from '../context/SettingsContext';

function PageDetail() {
  const { slug } = useParams();
  const { settings } = useSettings();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/pages/${slug}`)
      .then(res => setPage(res.data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container" style={{ padding: '2rem' }}>Yukleniyor...</div>;
  if (!page) return <div className="container" style={{ padding: '2rem' }}>Sayfa bulunamadı.</div>;

  return (
    <>
      <Helmet>
        <title>{page.meta_title || page.title} | {settings.site_title || ''}</title>
        {page.meta_description && <meta name="description" content={page.meta_description} />}
        <meta property="og:title" content={page.meta_title || page.title} />
        <meta property="og:description" content={page.meta_description || ''} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        {page.image_path && <meta property="og:image" content={`${window.location.origin}${getImageUrl(page.image_path)}`} />}
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>{page.title}</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link> / <span>{page.title}</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="page-content">
            {page.image_path && (
              <img src={getImageUrl(page.image_path)} alt={page.title} style={{ width: '100%', marginBottom: '1.5rem', borderRadius: '8px' }} />
            )}
            <div dangerouslySetInnerHTML={{ __html: page.content }} />
          </div>
        </div>
      </section>
    </>
  );
}

export default PageDetail;
